// removed by extract-text-webpack-plugin
module.exports = {"detail_card":"components-zxjfgl-jffagl-detail-detail_card-I_YU7","editIcon":"components-zxjfgl-jffagl-detail-editIcon-FzF75","deleteIcon":"components-zxjfgl-jffagl-detail-deleteIcon-1L4VT","main_right_content":"components-zxjfgl-jffagl-detail-main_right_content-3sRSa","table":"components-zxjfgl-jffagl-detail-table-1qiSu"};


//////////////////
// WEBPACK FOOTER
// ./components/zxjfgl/jffagl/detail.css
// module id = 728
// module chunks = 0